module.exports = {
	"id": "GY",
	"name": "Guyana",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.00521,
			"7": null,
			"8": 0.01563,
			"9": 0.02084,
			"10": null,
			"11": 0.02605,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.00521,
			"17": null,
			"18": 0.01563,
			"19": null,
			"20": 0.01563,
			"21": null,
			"22": 0.0521,
			"23": 0.00521,
			"24": null,
			"25": 0.00521,
			"26": 0.01042,
			"27": null,
			"28": 0.01042,
			"29": 0.03126,
			"30": null,
			"31": 0.01563,
			"32": 0.01563,
			"33": 0.03126,
			"34": 0.03647,
			"35": 0.01042,
			"36": 0.03126,
			"37": 0.00521,
			"38": 0.04168,
			"39": 0.02084,
			"40": 0.01563,
			"41": 0.02084,
			"42": 0.07294,
			"43": 0.3126,
			"44": 0.15109,
			"45": 0.13546,
			"46": 0.01563,
			"47": 0.06773,
			"48": 0.06773,
			"49": 0.49495,
			"50": 0.26571,
			"51": 1.20872,
			"52": 0.43243,
			"53": 20.74622,
			"54": 5.62159,
			"55": 0.16151,
			"56": 0.03126,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.01563,
			"4": null,
			"5": null,
			"6": null,
			"7": 0.01042,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.02084,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.01042,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.01042,
			"23": null,
			"24": null,
			"25": 0.00521,
			"26": 0.03126,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.07815,
			"31": 0.03126,
			"32": null,
			"33": 0.01563,
			"34": null,
			"35": 0.03126,
			"36": 0.01563,
			"37": null,
			"38": 0.04689,
			"39": 0.01042,
			"40": 0.01563,
			"41": 0.03647,
			"42": 0.01563,
			"43": 0.08857,
			"44": 0.05731,
			"45": 0.08857,
			"46": 0.05731,
			"47": 0.43243,
			"48": 0.32302,
			"49": 4.35035,
			"50": 0.41159,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.00521
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.04689,
			"28": null,
			"29": 0.20319,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.27092,
			"34": null,
			"35": 0.02084,
			"36": 0.00521,
			"37": 0.54705,
			"38": 0.04689,
			"39": 0.02084,
			"40": 0.58873,
			"41": 0.07815,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.03647
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.02084,
			"9": 0.02605,
			"10": 0.28134,
			"3.1": null,
			"3.2": null,
			"5.1": 0.03126,
			"6.1": 0.00521,
			"7.1": null,
			"9.1": 0.10941
		},
		"ios_saf": {
			"8": 0,
			"10": 2.61299485429,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0704171877602,
			"8.1-8.4": 0.130092770608,
			"9.0-9.2": 0.0620626061615,
			"9.3": 0.946852581182
		},
		"android": {
			"3": 0,
			"4": 0.0989438242894,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0123679780362,
			"4.1": 0.356904509044,
			"4.2-4.3": 0.89226127261,
			"4.4": 2.04601693798,
			"4.4.3-4.4.4": 2.06368547804
		},
		"ie": {
			"6": null,
			"7": 0.00523932457786,
			"8": 0.241008930582,
			"9": 0.0943078424015,
			"10": 0.225290956848,
			"11": 2.22671294559,
			"5.5": null
		},
		"op_mob": {
			"0": 0.263934525465,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00733151459626
		},
		"edge": {
			"12": 0.56268,
			"13": 1.08889,
			"14": 1.27124
		},
		"ie_mob": {
			"10": 0.141676056338,
			"11": 0.576823943662
		},
		"bb": {
			"7": 0.49816,
			"10": null
		},
		"samsung": {
			"0": 4.73252
		},
		"and_uc": {
			"0": 3.09434
		},
		"op_mini": {
			"0": 3.55594395994
		},
		"and_chr": {
			"0": 30.51207
		},
		"and_ff": {
			"0": 0.02395
		}
	},
	"total": 97.2188
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GY.json
 ** module id = 541
 ** module chunks = 0
 **/